var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{attrs:{"title":""}},[_c('div',[_c('vue-element-loading',{attrs:{"active":_vm.loading,"color":"#00cca2","spinner":"spinner"}}),_c('ve-bar',{attrs:{"legend":{show:false},"judge-width":"","grid":{right: '5%'},"toolbox":_vm.toolbox,"title":{
            text:'校区跟进统计',
            textStyle: {
                fontSize: 15,
            },
            subtextStyle: {
                fontSize: 12.5
            }
        },"data":_vm.studio_follow_data,"settings":{label: { show: true, position: 'right'},xAxisType: ['KMB', 'KMB']},"extend":{
        xAxis:{
            splitLine: {
            lineStyle: {
                type: 'dotted'
            }
            }
        },
        yAxis:{
        inverse: true,  
        splitLine:{show: false},
        axisLabel: {
            color: '#333',
            rich: {
                b: {
                    color: '#f4bc2f',
                    align: 'center',
                }
            },
            formatter: function(params,index) {
                return [
                        (params + " {b| " + (index + 1) + "}")
                    ].join('\n')
            }
        }
    }, series:{type:'bar',barMaxWidth:10,margin:80,itemStyle:{
        normal:{
            color: function(params) {
                return {
                    type: 'linear',
                    colorStops: [{
                        offset: 0,
                        color: '#effffb'
                        
                    }, {
                        offset: 1,                    
                        color: '#23d9ae'
                    }],
                }
        },barBorderRadius:[0,30,30,0]}}},dataZoom:[{type:'slider'}]}}}),(_vm.first>0 && _vm.studio_follow_data.rows.length == 0)?_c('LEmpty'):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }